<template>
    <div class="container">
        <div class="events-details-header" style="margin-top: 30px;">
            <ul v-for="activityItem of activity" :key="activityItem.activity_id">
                <li><i class='bx bx-calendar'></i>{{ activityItem.activity_time }}</li>
                <li><i class='bx bx-map'></i>{{ activityItem.activity_location }}</li>
                <li><i class='bx bx-time'></i>{{ activityItem.activity_header }}</li>
            </ul>
        </div>
        <lightgallery :settings="{ speed: 500, plugins: plugins }" :onInit="onInit" :onBeforeSlide="onBeforeSlide"
            class="row" >
            <a v-for="image in images" :key="image" className="gallery-item" :data-src="getImgUrl('etkinlikler', image)"
                class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-gallery-item">
                    <img className="img-responsive" :src="getImgUrl('etkinlikler', image)" />
                </div>
            </a>
        </lightgallery>
    </div>
</template>

<script>

import axios from "axios";


import Lightgallery from 'lightgallery/vue';
import lgZoom from 'lightgallery/plugins/zoom';
let lightGallery = null;


export default {
    
    name: 'GalleryTwoColumn',
    props: ['pathUrl'],

    created() {
        this.getActivity();
        this.getActivityImages();
    },
    
    

    components: {
        Lightgallery,
    },
    watch: {
        items() {
            this.$nextTick(() => {
                lightGallery.refresh();
            });
        },
    },
    data: () => ({
        activity: [],
        images: [],
        errors: [],

        plugins: [lgZoom],
        
    }),
    methods: {
        onInit: (detail) => {
            lightGallery = detail.instance;
        },
        onBeforeSlide: () => {
            console.log('calling before slide');
        },
        getUrl(data, pet) {
            return this.pathUrl + '?data=' + data + '&id=' + pet
        },
        getActivity() {
            axios
                .get(this.getUrl('activity_id', this.$route.params.id))
                .then(response => (this.activity = response.data.result))
                .catch(error => {
                    this.errors.push(error);
                });
        },
        getActivityImages() {
            axios
                .get(this.getUrl('activity_image', this.$route.params.id))
                .then(response => (this.images = response.data.result))
                .catch(error => {
                    this.errors.push(error);
                });
        },
        getImgUrl(category, pet) {
            return require('../../../../assets/resimler/' + category + '/' + pet)
        }
    }

};
</script>
<style lang="css">
@import url('https://cdn.jsdelivr.net/npm/lightgallery@2.1.0-beta.1/css/lightgallery.css');
@import url('https://cdn.jsdelivr.net/npm/lightgallery@2.1.0-beta.1/css/lg-zoom.css');
</style>